import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePreferences, FONT_SIZE_LIMITS } from '../context/PreferencesContext';
import { Label } from './ui/label';

const KeyTitle = {
  quranArabicFontSize: 'settings.text_quran_arabic',
  quranTranslationFontSize: 'settings.text_quran_translation',
  hadithFontSize: 'settings.text_hadith',
};

const FontSizeRow = ({ prefKey }) => {
  const { t } = useTranslation();
  const { preferences, bumpFontSize } = usePreferences();
  const limits = FONT_SIZE_LIMITS[prefKey];
  const value = preferences.textPreferences[prefKey];
  const atMin = value <= limits.min;
  const atMax = value >= limits.max;
  return (
    <div className="flex items-center justify-between gap-3" data-testid={`text-row-${prefKey}`}>
      <Label className="text-sm text-text-primary flex-1">{t(KeyTitle[prefKey])}</Label>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => bumpFontSize(prefKey, -1)}
          disabled={atMin}
          aria-label={t('common.decrease')}
          className="w-8 h-8 rounded border border-border bg-background hover:bg-surface-elevated disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
          data-testid={`text-decrease-${prefKey}`}
        >
          <Minus className="w-4 h-4 text-text-primary" />
        </button>
        <span
          className="text-sm font-medium text-primary min-w-[3rem] text-center"
          data-testid={`text-value-${prefKey}`}
        >
          {value}px
        </span>
        <button
          type="button"
          onClick={() => bumpFontSize(prefKey, +1)}
          disabled={atMax}
          aria-label={t('common.increase')}
          className="w-8 h-8 rounded border border-border bg-background hover:bg-surface-elevated disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
          data-testid={`text-increase-${prefKey}`}
        >
          <Plus className="w-4 h-4 text-text-primary" />
        </button>
      </div>
    </div>
  );
};

export const TextSizeControls = () => {
  const { t } = useTranslation();
  const { reset } = usePreferences();
  return (
    <div className="space-y-4" data-testid="text-size-controls">
      <div>
        <Label className="text-sm text-text-secondary">{t('settings.text_size')}</Label>
      </div>
      <div className="space-y-3">
        <FontSizeRow prefKey="quranArabicFontSize" />
        <FontSizeRow prefKey="quranTranslationFontSize" />
        <FontSizeRow prefKey="hadithFontSize" />
      </div>
      <button
        type="button"
        onClick={reset}
        className="text-xs text-text-muted hover:text-primary underline-offset-2 hover:underline"
        data-testid="text-reset-btn"
      >
        {t('common.reset')}
      </button>
    </div>
  );
};
